import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ClientSignUpConfirmComponent } from "./client-sign-up-confirm.component";

const routes: Routes = [
  {path: '', component: ClientSignUpConfirmComponent}
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ClientSignUpConfirmRoutingModule {}